module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0075.jpg?v=90191ee1";